// extracted by mini-css-extract-plugin
export default {"title":"_38c684f13e","bld":"b86a14064e"};